import { round } from '@/utils/mathUtils';
import type { MutableRefObject } from 'react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { IItemData } from '@/pages/PurchasesContainer/RequestPerHand/api/HandRequest.interface';

interface QtyPriceSectionProps {
  selectedItem: IItemData | null;
  suppliar: boolean;
  qtyInput: string;
  qtyRef: MutableRefObject<HTMLInputElement | null>;
  handleQtyChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleQtyBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  handleFocusSelect: (e: React.FocusEvent<HTMLInputElement>) => void;
  handleQtyKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  isPending: boolean;
}

export const QtyPriceSection = ({
  selectedItem,
  suppliar,
  qtyInput,
  qtyRef,
  handleQtyChange,
  handleQtyBlur,
  handleFocusSelect,
  handleQtyKeyDown,
  isPending,
}: QtyPriceSectionProps) => {
  return (
    <div className="grid grid-cols-1 gap-1 md:grid-cols-[100px_70px_1fr]">
      <div>
        <Label className="text-center text-xs" htmlFor="qty">
          الكمية
        </Label>
        <Input
          id="qty"
          type="number"
          step="1"
          min="1"
          ref={qtyRef}
          value={qtyInput}
          className="text-xl"
          onChange={handleQtyChange}
          onBlur={handleQtyBlur}
          onFocus={handleFocusSelect}
          onKeyDown={handleQtyKeyDown}
          placeholder="> 1 (Integer)"
          disabled={!selectedItem || !suppliar || isPending}
        />
      </div>
      <div>
        <Label className="text-center text-xs" htmlFor="item-name">
          الجمهور
        </Label>
        <div className="flex h-10 w-full items-center rounded-md border border-input bg-gray-100 px-3 py-2 text-xl text-gray-700">
          {selectedItem?.Price
            ? round(selectedItem?.Price, 2).toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })
            : '-'}
        </div>
      </div>
      <div>
        <Label className="text-center text-xs">الإجمالي</Label>
        <div className="flex h-10 w-full items-center rounded-md border border-input bg-gray-100 px-3 py-2 text-lg text-gray-700">
          {selectedItem?.Price && qtyInput
            ? round(selectedItem.Price * parseInt(qtyInput), 2).toLocaleString(
                'en-US',
                {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                },
              )
            : '-'}
        </div>
      </div>
    </div>
  );
};
